import React, { useEffect, useState } from "react";
import { InputText, SelectDropdown } from "commons/input-controls";
import AlignButtons from "pages/report-constructor/align-buttons/align-buttons";
import DataFieldsContainer from "pages/report-constructor/items/data-fields/data-fields.container";
import s from "./line-chart.module.scss";
import { StandartButton } from "commons/form-controls";
import { ReactComponent as SaveIcon } from 'assets/icons/save.svg';

const LineChartComponent = (props) => {

    const [fields, setFields] = useState(props.parameters && props.parameters.parameters.ANALYTICS_PARAMETERS && props.parameters.parameters.ANALYTICS_PARAMETERS.fields ? props.parameters.parameters.ANALYTICS_PARAMETERS.fields : []); 
    const [dateField, setDateField] = useState(props.parameters && props.parameters.parameters.ANALYTICS_PARAMETERS && props.parameters.parameters.ANALYTICS_PARAMETERS.dateField ? props.parameters.parameters.ANALYTICS_PARAMETERS.dateField : null);
    const [parameters, setParameters] = useState(props.parameters && props.parameters.parameters ? props.parameters.parameters : null);
    const [rerender, setRerender] = useState(false);
    
    useEffect(() => {
        setParameters(props.parameters && props.parameters.parameters ? props.parameters.parameters : null);
        setRerender(!rerender);
    }, [props]);

    const updateParameters = (type, parameter, value) => {
        let params = parameters;
        let fontParams = {...params[type]}
        fontParams[parameter] = value;
        params[type] = fontParams
        if(value === ''){
            delete params[type][parameter];
        }
        if(parameter == 'dateField'){
            params[type].fields.length = 1;
        }
        else if(parameter == 'fields' && params[type].fields.length > 1){
            delete params[type].dateField;
        }
        props.updateComponent(props.index, params)
    }

    const saveLineChart = () => {
        let type = 'LINE_CHART'
        props.updateTemplateComponents(parameters, type);
    }

    const align = (align) => {
        let params = {...parameters};
        params.ALIGNMENT = align;
        props.updateComponent(props.index, params);
        //setParameters(params);
        //setRerender(!rerender);
    }

    return (
        <div className={s.LineChartComponent}>
            <div className={s.ContentBlock}>
                <AlignButtons alignItems={align} getValue={props.getValue} alignment={parameters.ALIGNMENT ? parameters.ALIGNMENT : null}/>
                <DataFieldsContainer 
                                    firstField={fields && fields[0] ? fields[0] : null} 
                                    secondField={fields && fields[1] ? fields[1] : null} 
                                    dateField={dateField}
                                    parameters={parameters.ANALYTICS_PARAMETERS}
                                    setParameters={updateParameters}
                                    type={'ANALYTICS_PARAMETERS'}
                                    availableFields={['first', 'second', 'dateField']}
                                    readOnly={props.isReadOnly}
                                    articles={props.parameters && props.parameters.type === "BAR_CHART" ? {first: "VERTICAL", second: "HORIZONTAL", dateField: "VERTICAL"} : null}
                                />
            </div>
            
        </div>
    )
}

export default LineChartComponent;